// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
 
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import AFCReportsPage from './AFCReportsPage';

const AFCReports: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasAFCReportsAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'AFCReports')
  );

  return (
    <CardContainer>
      <Switch>
        <Route exact path={`${baseURL}`}>
          <AFCReportsPage/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { AFCReports };
